// components/CommunitySection/CommunitySection.jsx
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { FaUniversity, FaBookReader, FaGraduationCap, FaPenNib, FaScroll } from 'react-icons/fa';
import './css/CommunitySection.css';
import { API_BASE } from '../config/api';

import HeroImg from './images/landing.webp';
const CommunitySection = () => {
  const defaultCommunity = useMemo(
    () => ({
      section_tag: 'انضمي لمجتمعنا',
      title_prefix: 'انضمي لأكثر من',
      title_highlight: '300+ باحثة متميزة',
      title_suffix: 'حققن النجاح وتجاوزن العقبات!',
      description_text:
        'هذه فرصتك لتكوني جزءًا من مجتمع التميز البحثي. احصلي على نصائح حصرية، تحديثات دورية، وخصومات خاصة للمشتركات في القائمة البريدية.',
      name_placeholder: 'الاسم الكريم',
      email_placeholder: 'البريد الإلكتروني',
      button_text: 'اشتركي الآن',
      partner1_text: 'جامعة الملك سعود',
      partner2_text: 'المكتبة الرقمية',
      partner3_text: 'البحث العلمي',
      partner4_text: 'دراسات عليا',
      partner5_text: 'مجلة العلوم',
    }),
    []
  );

  const [community, setCommunity] = useState(defaultCommunity);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/api/community`)
      .then((res) => {
        const db = res.data?.community;
        if (!mounted) return;
        setCommunity(db ? { ...defaultCommunity, ...db } : defaultCommunity);
      })
      .catch((err) => {
        console.error('Failed to load community section:', err);
        if (!mounted) return;
        setCommunity(defaultCommunity);
      });

    return () => {
      mounted = false;
    };
  }, [defaultCommunity]);

  return (
    <section className="community-section" dir="rtl">
      <div className="container">
        <div className="row align-items-center mb-5">
          
          {/* 1. Image Composition (Right in RTL) */}
          <div className="col-lg-6 mb-5 mb-lg-0 position-relative">
            <motion.div 
              className="composition-wrapper"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              {/* Decorative Elements */}
              <div className="deco-circle"></div>
              <div className="deco-dots"></div>
              <svg className="deco-leaf" viewBox="0 0 100 100">
                <path d="M50 0 C20 0 0 20 0 50 C0 80 20 100 50 100 C80 100 100 80 100 50 C100 20 80 0 50 0 Z M50 90 Q30 90 30 50 Q30 10 50 10 Q70 10 70 50 Q70 90 50 90 Z" fill="#402336" opacity="0.1"/>
              </svg>
              <svg className="deco-squiggle" viewBox="0 0 200 50">
                <path d="M10 25 Q 50 10, 90 25 T 180 25" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
              </svg>

              {/* The Polaroid Image */}
              <div className="polaroid-frame">
                <img 
                  src={HeroImg} 
                  alt="Dr Noha Community" 
                />
              </div>
            </motion.div>
          </div>

          {/* 2. Text & Form (Left in RTL) */}
          <div className="col-lg-6 text-lg-start community-section-text">
            <motion.div 
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <span className="section-tag">{community.section_tag}</span>
              <h2 className="section-title">
                {community.title_prefix}{' '}
                <span className="highlight">{community.title_highlight}</span>{' '}
                <br />
                {community.title_suffix}
              </h2>
              <p className="section-desc">
                {community.description_text}
              </p>

              {/* Sign Up Form */}
              <form className="signup-form">
                <div className="form-group">
                  <input
                    type="text"
                    placeholder={community.name_placeholder}
                    className="form-control-custom"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    placeholder={community.email_placeholder}
                    className="form-control-custom"
                  />
                </div>
                <button type="submit" className="btn-signup">
                  {community.button_text}
                </button>
              </form>
            </motion.div>
          </div>

        </div>

        {/* 3. Partners/Logos Row */}
        <motion.div 
          className="logos-row"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {/* Using Icons as placeholders for Partner Logos */}
          <div className="partner-logo">
            <FaUniversity /> <span>{community.partner1_text}</span>
          </div>
          <div className="partner-logo">
            <FaBookReader /> <span>{community.partner2_text}</span>
          </div>
          <div className="partner-logo">
            <FaGraduationCap /> <span>{community.partner3_text}</span>
          </div>
          <div className="partner-logo">
            <FaPenNib /> <span>{community.partner4_text}</span>
          </div>
          <div className="partner-logo">
            <FaScroll /> <span>{community.partner5_text}</span>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default CommunitySection;